"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SuggestionFooter_1 = require("./SuggestionFooter");
Object.defineProperty(exports, "SuggestionFooter", { enumerable: true, get: function () { return SuggestionFooter_1.SuggestionFooter; } });
//# sourceMappingURL=index.js.map